export default __webpack_public_path__ + "static/media/game_5_m.7c7e783d.png";